import React, { useEffect } from 'react';
import { preloadImage } from './PreloadImg';



const ImageComponent = ({ src }) => {
  useEffect(() => {
    preloadImage(src).then(() => console.log('Image preloaded'));
  }, [src]);

  return <img src={src} alt="Preloaded" />;
};

export default ImageComponent;